<template>

  <div>
    
    <div v-if="permissions.includes('manage_candidates')">

      <div
        v-if="!selectedJob"
        class="alert alert-warning">
        {{ $t('To share the candidate, select a job') }}
      </div>

      <div
        v-if="selectedJob"
        class="card">
        <div class="card-body">
          <CandidateShareForm
            :initValue="{}"
            @created="createdShare" />
        </div>
      </div>
    </div>

    <CandidateShareList />

  </div>

</template>

<script>
import CandidateShareForm from './CandidateShareForm'
import CandidateShareList from './CandidateShareList'

export default {
  name: 'CandidateShare',
  components: {
    CandidateShareForm,
    CandidateShareList
  },
  props: [
  ],
  data () {
    return {
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    candidate () {
      return this.$store.getters.getCandidate
    },
    selectedJob () {
      return this.$store.getters.getCandidateSelectedJob
    }
  },
  created () {
  },
  methods: {
    /*
    createdShare
    */
    createdShare (share) {
      this.$store.dispatch('refreshSelectShareCandidates')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Share/CandidateShare.vue